var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E39153",
    strokeWidth: 2,
    d: "M7.297 37.703c-8.396-8.396-8.396-22.01 0-30.406 8.396-8.396 22.01-8.396 30.406 0 8.396 8.396 8.396 22.01 0 30.406-8.396 8.396-22.01 8.396-30.406 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E39153",
    d: "M29.06 31.081L23 25.021l-6.06 6.06-2.021-2.02L20.979 23l-6.06-6.06 2.02-2.021L23 20.979l6.06-6.06 2.021 2.02L25.021 23l6.06 6.06z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancel);
export default __webpack_public_path__ + "static/media/ic-cancel.880ed70fb27015983847c0cb135eee1f.svg";
export { ForwardRef as ReactComponent };